const initSelect2 = (selector) => {
  $(".form-field-select select").select2({
    minimumResultsForSearch: -1,
    width: "100%",
    dropdownCssClass: "form-field-select__dropdown",
    tags: false
  });
  $(".simple-select").select2({
    minimumResultsForSearch: -1,
    width: "100%",
    dropdownCssClass: "simple-select-dropdown",
    tags: false,
    containerCssClass: "test"
  });
  $(".form-field-select select").on("select2:select", function(e) {
    this.closest(".form-group").classList.add("not-empty");
  });
  $(".form-field-select select").on("select2:clear", function(e) {
    this.closest(".form-group").classList.remove("not-empty");
  });
  $(".form-field-select select").on("select2:opening select2:closing", function(event) {
    var $searchfield = $(this).parent().find(".select2-search__field");
    $searchfield.prop("disabled", true);
  });
};
export default initSelect2;
